import { Checkbox } from '@components/checkbox';
import { FileLink } from '@components/fileLink';
import { SimpleLink } from '@components/simpleLink';
import { cn } from '@utils/helpers';
import type { PriceInfoBodyProps } from './types';

export const PriceInfoBody: React.FC<PriceInfoBodyProps> = ({ title, checked, file, archive, onCheckChange }) => {
  return (
    <tbody>
      <tr className="max-desktop:flex max-desktop:flex-wrap max-desktop:items-center last:[&>td]:border-b-0">
        <td className={cn('Subscription-name', 'max-desktop:flex-1 max-desktop:min-w-[220px] max-desktop:text-accent', 'max-[620px]:w-[80%] max-[620px]:flex-none')}>{title}</td>
        <td className={cn('Subscription-checkbox', 'max-desktop:w-10', 'max-[620px]:[&_.Checkbox]:mr-0')}>
          <Checkbox indeterminate={false} checked={checked} checkboxClickUpdate={(newVal) => onCheckChange(newVal)} />
        </td>
        <td
          className={cn(
            'Subscription-file',
            '[&_a]:flex [&_a]:items-center [&_a]:justify-start [&_a]:mb-0 [&_a]:py-[5px] [&_a]:text-sm [&_a]:tracking-normal [&_a]:normal-case [&_a]:font-[Arial,sans-serif]',
            '[&_a_.FileLink-header]:text-sm [&_a_.FileLink-header]:normal-case [&_a_.FileLink-header]:font-[Arial,sans-serif]',
            'max-desktop:w-[200px] max-desktop:[&_a]:w-auto',
            'max-[620px]:w-full',
          )}
        >
          {file ? <FileLink fileLink={file} expanded={false} /> : <span className="FileLink-header h4">–</span>}
        </td>
        <td
          className={cn(
            'Subscription-link text-right',
            '[&_a]:text-[13px] [&_a]:leading-6 [&_a]:tracking-normal [&_a]:uppercase [&_a]:text-accent [&_a]:no-underline [&_a]:font-[BonnCaps,Arial,sans-serif]',
            '[&_a::after]:content-["_»"]',
            'max-desktop:w-full max-desktop:text-right',
            'max-[620px]:mt-5 max-[620px]:w-full',
            'max-[620px]:[&_a]:flex max-[620px]:[&_a]:w-[calc(100%-3px)] max-[620px]:[&_a]:items-center max-[620px]:[&_a]:justify-between max-[620px]:[&_a]:border-b max-[620px]:[&_a]:border-[#e6e6e6]',
            'max-[620px]:[&_a::after]:text-[1.2em]',
          )}
        >
          {archive && <SimpleLink simpleLink={archive} />}
        </td>
      </tr>
    </tbody>
  );
};
